import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Plane, Train, MapPin } from 'lucide-react';

const ZaventemGareMidi = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Zaventem Gare du Midi | Transfert Aéroport - Gare Bruxelles</title>
        <meta name="description" content="Transfert Zaventem Gare du Midi. Connexion aéroport-train, 25 min, prix fixe. Thalys, Eurostar. Service porte-à-porte 24/7." />
        <meta name="keywords" content="zaventem gare midi, transfert aeroport gare, zaventem thalys, zaventem eurostar" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/zaventem-gare-midi" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Zaventem ↔ Gare du Midi
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Transfert privé Aéroport Zaventem - Gare du Midi. Connexion train-avion. 25 min.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Aéroport Zaventem" defaultDropoff="Gare du Midi, Bruxelles" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert Zaventem - Gare du Midi</h2>
          <p className="text-gray-300 mb-4">
            <strong>Connexion optimale</strong> entre l&apos;aéroport Zaventem et la Gare du Midi Bruxelles (Thalys, Eurostar, TGV). 
            Trajet de 25 minutes, suivi de vol, aide aux bagages. Service 24/7.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Correspondances Prises en Charge</h3>
          <ul className="text-gray-300 space-y-2">
            <li>✈️ Vol international → Thalys Paris/Amsterdam</li>
            <li>🚄 Eurostar → Vol international</li>
            <li>🚆 TGV France → Vol Zaventem</li>
            <li>🌍 Vol arrivée → Train longue distance</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default ZaventemGareMidi;